/**
 * Model to hold ranking settings
 */
export class IdentityRankingPointsSettings {
    public placementPoints: PlacementPoints[] = null;

    public isEmpty(): boolean {
        return !this.placementPoints || !this.placementPoints.length;
    }

    public clone(): IdentityRankingPointsSettings {
        const clone: IdentityRankingPointsSettings = new IdentityRankingPointsSettings();
        clone.placementPoints = this.placementPoints ?
            this.placementPoints.map((pp: PlacementPoints) => pp.clone()) : null;

        return clone;
    }

    public serialize(): any {
        if (this.isEmpty()) {
            return null;
        }

        return {
            placementPoints: this.placementPoints.map((pp: PlacementPoints) => pp.serialize()),
        };
    }

    public deserialize(json: any): IdentityRankingPointsSettings {
        if (!json || !json.placementPoints) {
            return this;
        }

        this.placementPoints = json.placementPoints.map((i: any) => new PlacementPoints(i.place, i.points));

        return this;
    }
}

export class PlacementPoints {
    public place: number;
    public points: number;

    constructor(place: number, points?: number) {
        this.place = place;
        this.points = points;
    }

    public clone(): PlacementPoints {
        return new PlacementPoints(this.place, this.points);
    }

    public serialize(): any {
        return {
            place: parseInt(`${this.place}`, null),
            points: parseFloat(`${this.points}`),
        };
    }
}
